import(/* webpackMode: "eager", webpackExports: ["Spin"] */ "__barrel_optimize__?names=Spin!=!/var/jenkins_home/workspace/jl-archives-front-net/node_modules/.pnpm/antd@5.24.3_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header","FixedBox"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/_component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/layout/zhCN.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavMenu"] */ "/var/jenkins_home/workspace/jl-archives-front-net/app/components/menu/main.tsx");
;
import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/jl-archives-front-net/app/globals.css");
